import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./components/App";
import Overlay from "./components/utils/Overlay";

window.addEventListener("load", () => {
  ReactDOM.render(
    <div className="app">
      <Router basename="/app">
        <App />
      </Router>
      <Overlay />
      <footer className="layout tac">
        <small>Contempas &copy; 2021 | </small>
        <a href="/terms" target="_blank">
          <small>Privacy Policy</small>
        </a>
      </footer>
    </div>,
    document.querySelector("#root")
  );
});
